import { render, staticRenderFns } from "./TheNavigationSubGroup.vue?vue&type=template&id=3610d896"
import script from "./TheNavigationSubGroup.vue?vue&type=script&lang=ts"
export * from "./TheNavigationSubGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports